import { render, staticRenderFns } from "./AddPillDrugPrescription.vue?vue&type=template&id=02170323&scoped=true"
import script from "./AddPillDrugPrescription.vue?vue&type=script&lang=js"
export * from "./AddPillDrugPrescription.vue?vue&type=script&lang=js"
import style0 from "./AddPillDrugPrescription.vue?vue&type=style&index=0&id=02170323&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02170323",
  null
  
)

export default component.exports